export const COLUMN_KEYS = {
  NOTE_AMOUNT: 'noteAmount',
  WIRE_AMOUNT: 'wireAmount',
  WAREHOUSE_PRINCIPAL: 'warehousePrincipal',
};

export const TABLE_INFO = {
  BODY_SECTION: 'body',
  CELL_RIGHT_ALIGN: 'right',
};

/** Default for `percentageBlankWhenTransactionIn` @Input (unit-tested for coverage). */
export function defaultPercentageBlankWhenTransactionIn(): string[] {
  return [];
}
